export enum FirstWeekOfYear {
  FirstJanuary = 'FirstJanuary',
  StartOfNextWeek = 'StartOfNextWeek',
}
